import {Component, inject, DestroyRef} from '@angular/core';
import {EmployeeItrentService} from '../../../services/http/employee/employee-itrent.service';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

@Component({
  selector: 'app-admin-synchronize',
  templateUrl: './admin-synchronize.component.html',
  styleUrls: ['./admin-synchronize.component.less'],
  imports: []
})
export class AdminSynchronizeComponent {
  private employeeItrentService = inject(EmployeeItrentService);
  private destroyRef = inject(DestroyRef);
  private destroy$ = new Subject<void>();

  constructor() {
    this.destroyRef.onDestroy(() => {
      this.destroy$.next();
      this.destroy$.complete();
    });
  }


  synchronizePositions() {
    this.employeeItrentService.synchronizePositions()
            .pipe(takeUntil(this.destroy$))
            .subscribe();
  }

  synchronizeAbsences() {
    this.employeeItrentService.synchronizeAbsences()
            .pipe(takeUntil(this.destroy$))
            .subscribe();
  }

  synchronizeDailyPatterns() {
    this.employeeItrentService.synchronizeDailyPatterns()
            .pipe(takeUntil(this.destroy$))
            .subscribe();
  }

  synchronizeContractHours() {
    this.employeeItrentService.synchronizeContractHours()
            .pipe(takeUntil(this.destroy$))
            .subscribe();
  }
}
